module.exports = __webpack_public_path__ + "static/hkgrotesk-bold-305765f0d101a7db3b9f60c9dc2d3a8e.eot";